export const BOT_ENV = {
  TEST: {
    title: `Test`,
    value: 'test',
    placeholder: 'Base url. e.g. https://staging.haptik.ai',
  },
  PRODUCTION: {
    title: `Production`,
    value: 'production',
    placeholder: 'Base url. e.g. https://production.haptik.ai',
  },
};
